import api from './Api';
let BASE_URL = "export/";

export default {
    getSpaceAdvertisersEarnings: (date) => {
        return api.get(`${BASE_URL}space-advertiser-earnings-report`, {
            params: {
                date
            }
        });
    },
    getEarningsByGeo: (date) => {
        return api.get(`${BASE_URL}earnings-by-geo`, {
            params: {
                date
            }
        });
    },
    getEarningsByAdvertiserThenByPublisher: (date) => {
        return api.get(`${BASE_URL}advertiser-by-publisher-earnings-report`, {
            params: {
                date
            }
        });
    }
}